module.exports = __webpack_public_path__ + "media/images/youtube_play_button-e5aba2ec8946fef00d13380a98d65b3c.png";